<template>
    <div class="media-object-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="others-title">
                    <h3>Media Object</h3>
                </div>

                <div class="d-flex media-object-content">
                    <div class="flex-shrink-0">
                        <img src="../../assets/images/avatar/avatar-1.jpg" alt="avatar-1">
                    </div>
                    <div class="flex-grow-1 ms-3">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas dolores voluptatum at, deserunt et voluptatem aliquam, eius esse repellat officia illum in dolorum ipsa excepturi molestias laudantium suscipit dicta nisi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem maiores voluptates ipsam nemo voluptatem beatae culpa quod provident officia accusantium, eligendi, praesentium, nihil aut libero temporibus. Ea, non. Commodi, architecto?
                    </div>
                </div>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Media Object Center</h3>
                </div>

                <div class="d-flex align-items-center media-object-content">
                    <div class="flex-shrink-0">
                        <img src="../../assets/images/avatar/avatar-2.jpg" alt="avatar-1">
                    </div>
                    <div class="flex-grow-1 ms-3">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas dolores voluptatum at, deserunt et voluptatem aliquam, eius esse repellat officia illum in dolorum ipsa excepturi molestias laudantium suscipit dicta nisi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem maiores voluptates ipsam nemo voluptatem beatae culpa quod provident officia accusantium, eligendi, praesentium, nihil aut libero temporibus. Ea, non. Commodi, architecto?
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MediaObject'
}
</script>

<style lang="scss">
/* Max width 767px */
@media only screen and (max-width: 767px) {
    .media-object-content.d-flex {
        display: block !important;
        img {
            margin-bottom: 20px;
            width: 100%;
        }
        .ms-3 {
            margin-left: 0!important;
        }
    }
}
</style>